import { SET_GENERAL_DATA } from '../actions/types'

const initialState = {}

const generalDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GENERAL_DATA:
      return action.payload
    default:
      return state
  }
}

export default generalDataReducer
